import { FC } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { useAuth0 } from '@auth0/auth0-react';
import { Link, useNavigate } from 'react-router-dom';
import { selectUser } from '../../redux/reducers/userSlice';
import { useAppSelector } from '../../redux/hooks';
import { Menubar } from 'primereact/menubar';
import { Roles } from '../../models/User';
import { getHeaderOptionsByRole } from './getHeaderOptionsByRole';
import { useCondition } from '../../experiments/ExperimentsProvider';
import HeaderProfileMenu from './HeaderProfileMenu';
import HeaderProfileMenuTeame223 from '../../experiments/TEAME-223/HeaderProfileMenuTeame223';
import { TEAME_223_FLAG_ID, TEAME_223_TREATMENT } from '../../experiments/TEAME-223/constants';
import WeeklyGoalWrapper from '../WeeklyGoal/WeeklyGoalWrapper';
import { selectTeacherOnboardingActive } from '../../redux/reducers/teacherIntroSlice';

const Header: FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  const userRedux = useAppSelector(selectUser);
  const adminRoles = [Roles.SITE_ADMIN, Roles.NETWORK_ADMIN];
  const rolesArray = [Roles.TEACHER, ...adminRoles];
  const isTeacherOrSiteAdminOrNetworkAdmin = userRedux?.roles.some(role => rolesArray.includes(role?.name));
  const teacherOnboardingActive = useAppSelector(selectTeacherOnboardingActive);
  const futureSelvesCondition = useCondition(TEAME_223_FLAG_ID);
  const showFutureSelfProfileMenu =
    futureSelvesCondition === TEAME_223_TREATMENT && !isTeacherOrSiteAdminOrNetworkAdmin;

  return (
    <Toolbar
      role="banner"
      className="left-0 right-0 fixed nc_header"
      start={
        <Link to="/" id="logo" aria-label="Teach to One Roadmaps home page">
          <div className="nc_logo" data-testid="logo" />
        </Link>
      }
      center={
        isAuthenticated &&
        userRedux !== null &&
        isTeacherOrSiteAdminOrNetworkAdmin &&
        !teacherOnboardingActive && <Menubar model={getHeaderOptionsByRole(userRedux, navigate)} id="headerNavBar" />
      }
      end={
        isAuthenticated && (
          <div className="tw-flex tw-row tw-gap-x-6 tw-items-center">
            {!isTeacherOrSiteAdminOrNetworkAdmin ? <WeeklyGoalWrapper /> : <></>}
            {showFutureSelfProfileMenu ? <HeaderProfileMenuTeame223 /> : <HeaderProfileMenu />}
          </div>
        )
      }
    />
  );
};

export default Header;
